import React, { useState, useEffect, useMemo } from 'react';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import { object, func, bool } from 'prop-types';
import { CloneObject } from '../../../utils/helpers';
import { FormError, FormLabel, Modal, Select } from '../../common';
import { useFormErrors } from '../../hooks/useFormErrors';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';


const ElementoEntidadModal = (props) => {

    const entityInit = {
        id: 0,
        idElemento: 0,
        entidad: '',
        idEntidad: 0
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
		listEntities: []
    });

    const mount = () => {
        setState({
			entity: props.data.entity,
			listEntities: props.data.listEntities
        });

        formSet({
            entidad: (props.data.listEntities.length === 1) ? props.data.listEntities[0].key : '',
            idEntidad: 0
        });
    }
    useEffect(mount, [props.data]);

    const [ formValues, formHandle, , formSet ] = useForm({
        entidad: '',
        idEntidad: 0
    });

	let listItems = useMemo(() => 
		(state.listEntities.find(f => f.key === formValues.entidad)??{children: []}).children,
		[state.listEntities]
	);

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
		row.entidad = formValues.entidad;
        row.idEntidad = parseInt(formValues.idEntidad);
		props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idEntidad <= 0) errors.idEntidad = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

	return (
		<Modal
			size="lg"
			title="Vínculo del elemento"
			onEscape={() => props.onDismiss()}
			body={(
				<div className="row">

					<div className="mb-3 col-12 col-md-4">
						<label htmlFor="entidad" className="form-label">Tipo vínculo</label>
                        <Select
                            name="entidad"
                            className="form-control"
							value={formValues.entidad}
							onChange={({ target }) => {
								formSet({
									entidad: target.value,
									idEntidad: 0
								});
							}}
                            disabled={state.listEntities.length === 1}
                            emptyOption="Sin selección"
                            emptyValue={''}
                            options={state.listEntities.map(entity => ({ value: entity.key, label: entity.value }))}
                        />
                        <FormError />
					</div>
					<div className="mb-3 col-12 col-md-8">
						<FormLabel htmlFor="idEntidad" required>Vínculo</FormLabel>
                        <Select
                            name="idEntidad"
                            className={`form-control ${errorOf('idEntidad') ? 'is-invalid' : ''}`}
                            value={formValues.idEntidad}
							onChange={formHandle}
                            options={listItems.map(item => ({ value: item.key, label: item.value }))}
                        />
                        <FormError message={errorOf('idEntidad')} />
					</div>

				</div>
			)}
			footer={(<>
				<button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onDismiss() } >Cancelar</button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() } >Aceptar</button>
			</>)}
		/>
	  );
	}

ElementoEntidadModal.propTypes = {
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

export default ElementoEntidadModal;
